var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"no-space",attrs:{"md":"12"}},[(!_vm.hideWeb2case)?_c('web-2-case'):_vm._e(),_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }